import _ from 'lodash'

export const state = {
    memberid:'',
    authkey:'',
    print: {},
    isAdmin:'',
    adminId:'',
    power:{},
    remark:'',
    nature:[],
}
export const mutations = {
    //设置授权信息
    setAuth (state, { authkey, memberid }) {
        state.authkey = authkey;
        state.memberid = memberid;
        localStorage.authkey = authkey;
        localStorage.memberid = memberid;
        
    },
    //移除授权信息
    removeAuth (state) {
        state.authkey = '';
        state.memberid = '';
        state.isAdmin = '';
        state.power = {};
        localStorage.authkey = '';
        localStorage.memberid = '';
        localStorage.isAdmin = '';
        localStorage.power = {};
        localStorage.nature = []
        
    },
    //从本地读取授权
    loadAuth (state) {
        state.authkey = localStorage.authkey || '';
        state.memberid = localStorage.memberid || '';
        state.isAdmin = localStorage.isAdmin || '';
        state.power = localStorage.power || {};
        state.remark = localStorage.remark || '';
        state.nature = localStorage.nature || [];
    },
    //设置打印数据
    setPrintData (state, printData) {
      state.print = printData
    },
    //保存权限
    setIsAdmin(state,{isAdmin}){
    	state.isAdmin = isAdmin;
    	localStorage.isAdmin = isAdmin;
    },
    //保存管理员id
    setadminId(state,{adminId}){
    	state.adminId = adminId
    },
    //保存菜单信息
    setmenupower(state,powerData){
    	state.power = powerData.power
    	localStorage.power = powerData.power
    },
    //保存底部登录信息
    setRemark(state,remark){
    	state.remark = remark.remark;
    	localStorage.remark = remark.remark
    },
    setNature(state,natureData){
    	state.nature = natureData.nature
    	localStorage.nature = natureData.nature
    }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js